/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1453
 */

var r = require(/* 728 */"../../994/2490/1177/728/index")
var i = function () {
  try {
    var e = r(Object, "defineProperty")
    e({}, "", {})
    return e
  } catch (t) {}
}()
module.exports = i
